import { AbacRuleName } from '@jupiterone/jupiter-types';
import * as abac from '@lifeomic/abac';

export default function enforce(
  operation: AbacRuleName,
  policy: any,
  attributes?: any
): boolean {
  if (policy && policy.rules) {
    return abac.enforce(operation, policy, attributes);
  } else {
    return false;
  }
}

export function enforceAny(
  operations: AbacRuleName[],
  policy: any,
  attributes?: any
): boolean {
  if (policy && policy.rules) {
    return abac.enforceAny(operations, policy, attributes);
  } else {
    return false;
  }
}
